import React, { useEffect, useState } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Container from "@material-ui/core/Container";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import { Checkbox, Grid, Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import DataService from "../../../../../Service";
import Loader from "../../../../../Components/Loader";
import Alert from "@material-ui/lab/Alert";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import TextField from "@material-ui/core/TextField";
import DialogActions from "@material-ui/core/DialogActions";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import AddSharpIcon from "@material-ui/icons/AddSharp";
import CustomInput from "../../../../../Components/CustomInput";
import { useDispatch, useSelector } from "react-redux";
import { showSnackbar } from "../../../../../../src/Components/Snackbar/SnackbarActions";
import { programInfo } from "../../../../../../src/Common/constant";

const useStyles = makeStyles((theme) => ({
  appBar: {
    backgroundColor: "#fff",
    color: "#232323",
    boxShadow: "0px 3px 6px #232323",
  },
  formTab: {
    "& h2": {
      fontSize: "1.2em",
    },
  },
  backButton: {
    marginRight: theme.spacing(2),
  },
  wrapper: {
    margin: "3%",
  },
  detail: {
    padding: "3%",
    backgroundColor: "#fff",
    boxShadow: "0px 3px 6px #232323",
  },
  paper: {
    textAlign: "center",
    color: theme.palette.text.secondary,
    "& span:last-child": {
      fontSize: "13px",
      color: "#303030",
    },
    "& svg": {
      width: "1.5em",
      height: "1.5em",
    },
  },
  bottomBar: {
    boxShadow: "0px 0px 6px #232323",
    padding: "15px",
    textAlign: "center",
    margin: "0 -24px",
    marginTop: "10px",
    position: "fixed",
    bottom: "0",
    left: "0",
    right: "0",
    zIndex: 1075,
    backgroundColor: "#fff",
  },
  buttonCss: {
    textTransform: "capitalize",
    width: "128px",
    height: "40px",
    fontWeight: 900,
  },
  duration: {
    float: "left",
    display: "flex",
    alignItems: "center",
    margin: "10px 0 10px 40px",
  },
}));

const youAreAllowedChargeAdditionallyArray = [
  { id: 1, name: "calls_between_sessions", value: "Calls between sessions" },
  { id: 2, name: "updates_on_progress", value: "Updates on progress" },
  { id: 3, name: "travel_time", value: "Travel time" },
  {
    id: 4,
    name: "programme_survey_questions",
    value: "Program survey questions",
  },
  { id: 5, name: "session_prep", value: "Session prep" },
  { id: 6, name: "extra_session", value: "Extra session" },
  { id: 7, name: "notes_consolidation", value: "Notes consolidation" },
  {
    id: 8,
    name: "sourcing_and_providing_resources",
    value: "Sourcing and providing resources",
  },
  { id: 9, name: "other_charge_additionally", value: "Other" },
];

const formsArray = [
  { id: 1, name: "coaching_agreement_form", value: "Coaching Agreement Form" },
  { id: 2, name: "evaluation_form", value: "Evaluation Form" },
  { id: 3, name: "coaching_request_form", value: "Coaching Request Form" },
  { id: 4, name: "coaching_review_form", value: "Coaching Review Form" },

  {
    id: 5,
    name: "coaching_initiation_form",
    value: "Coaching Initiation Form",
  },
  { id: 6, name: "quality_assurance_form", value: "Quality Assurance Form" },
  { id: 7, name: "pre_questionnaire_form", value: "Pre-questionnaire Form" },
  { id: 8, name: "mid_term_review_form", value: "Mid-term Review Form" },
  { id: 9, name: "follow_up_form", value: "Follow up Form" },
  {
    id: 10,
    name: "stmt_of_work_form_client_name",
    value: "Statement of Work Form - Client name",
  },
  {
    id: 11,
    name: "stmt_of_work_form_partner_name",
    value: "Statement of Work Form - Partner name",
  },
];

const assignCoachArray = [
  { id: 1, name: "straight_match", value: "Straight Match" },
  {
    id: 2,
    name: "straight_match_with_chemistry",
    value: "Straight Match with Chemistry",
  },
  { id: 3, name: "short_list", value: "Shortlist" },
];

const authorisationArray = [
  { id: 1, name: "verbal_360", value: "Verbal 360" },
  { id: 2, name: "attending_meetings", value: "Attending meetings" },
  { id: 3, name: "online_360", value: "Online 360" },
  { id: 4, name: "team_session", value: "Team Session" },
  { id: 5, name: "email_360", value: "Email 360" },
  { id: 6, name: "stakeholder_calls", value: "Stakeholder calls" },
  { id: 7, name: "psychometrics", value: "Psychometrics" },
  { id: 8, name: "shadowing", value: "Shadowing" },
  { id: 9, name: "interim_review_meeting", value: "Interim Review Meeting" },
  { id: 10, name: "travel_times", value: "Travel Time" },
  { id: 11, name: "extra_sessions", value: "Extra sessions" },
  { id: 12, name: "feedback_sessions", value: "Feedback Sessions" },
  { id: 13, name: "other_optional_extras", value: "Other" },
];

const StandardExecutiveCoaching = (props) => {
  const { currentSelection, setFetchApiFlag, fetchApiFlag } = props;
  const classes = useStyles();
  const dispatch = useDispatch();

  const [nextButtonLoading, setNextButtonLoading] = useState(false);
  const [moduleSetupLoading, setModuleSetupLoading] = useState(false);
  const [templateInfoLoader, setTemplateInfoLoader] = useState(false);
  const [checkBoxValue, setCheckBoxValue] = useState({});
  const [chekedFields, setChekedFields] = useState([]);
  const [programRateId, setProgramRateId] = useState([]);
  const [moduleSetups, setModuleSetups] = useState([]);
  const [programRateValue, setProgramRateValue] = useState("external");
  const [templateInfo, setTemplateInfo] = useState();
  const [otherTextState, setOtherTextState] = useState({});

  const [youAreAllowedChargeAdditionally, setYouAreAllowedChargeAdditionally] =
    useState(youAreAllowedChargeAdditionallyArray);
  const [optionalAuthorisation, setOptionalAuthorisation] =
    useState(authorisationArray);

  // Modal state
  const [manageModal, setManageModal] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [modalLabel, setModalLabel] = useState("");
  const [textAreaValue, setTextAreaValue] = useState("");
  const [modalSubmitFlag, setModalSubmitFlag] = React.useState(false);

  useEffect(() => {
    moduleSetup();
  }, []);

  useEffect(() => {
    fetchProgramInfo();
  }, [fetchApiFlag]);

  const moduleSetup = () => {
    setModuleSetupLoading(true);
    DataService.getDirectData(`/module_setups/listing_modules`)
      .then((res) => {
        if (res?.["success"]) {
          setModuleSetups(res["modules"]);
          setModuleSetupLoading(false);
        }
      })
      .catch((error) => {
        setModuleSetupLoading(false);
      });
  };

  const fetchProgramInfo = () => {
    setTemplateInfoLoader(true);
    DataService.getData(
      { assignment_id: currentSelection?.id },
      `assignment_program_info`
    )
      .then((res) => {
        if (res.success) {
          setTemplateInfoLoader(false);

          props?.setStepperData(
            res?.header_name || "Standard executive coaching"
          );
          props?.setHeaderType("programme_info");
          setFetchApiFlag(false);

          setTemplateInfo(res?.programme_info);
        }
      })
      .catch(() => {
        setTemplateInfoLoader(false);
      });
  };

  const handleCheckboxValue = (event) => {
    setCheckBoxValue({
      ...checkBoxValue,
      [event.target.name]: Boolean(event.target.checked),
    });
  };

  const handleProgramRate = (event) => {
    if (chekedFields.includes(+event.target.value)) {
      setChekedFields(chekedFields.filter((el) => el !== +event.target.value));
    } else {
      setChekedFields((prevChecked) => [...prevChecked, +event.target.value]);
    }
    setProgramRateId(+event.target.value);
  };

  const handleChangeProgramRate = (event) => {
    setProgramRateValue(event.target.value);
  };

  const handleOtherTextStateValue = (valueProps, nameProps) => {
    setOtherTextState({ ...otherTextState, [nameProps]: valueProps });
  };

  const handleTextAreaValue = (inputStateValue, inputId, index) => {
    // console.log("inputStateValue", inputStateValue);
    setTextAreaValue({ ...textAreaValue, [inputId]: inputStateValue });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    formData.append("description", textAreaValue?.description || "");
    formData.append(
      "duration_in_month",
      textAreaValue?.duration_in_month || ""
    );
    formData.append("assignment_id", currentSelection?.id);
    checkBoxValue &&
      Object.keys(checkBoxValue).forEach((item) =>
        formData.set(item, checkBoxValue[item])
      );

    const moduleArray = moduleSetups
      ?.filter((item) => programInfo.includes(item?.module_name?.toLowerCase()))
      ?.map((value) => value.id);

    if (Array.from(chekedFields).length) {
      if (templateInfo && Object.keys(templateInfo)?.length) {
        setNextButtonLoading(true);
        DataService.updateData(formData, "", "assignment_program_rate")
          .then((res) => {
            if (res?.success) {
              setNextButtonLoading(false);
              // fetchProgramInfo();
              props.onNextClick();
            }
          })
          .catch((error) => {
            setNextButtonLoading(false);
          });
      } else {
        setNextButtonLoading(true);
        DataService.createData(formData, "assignment_program_info")
          .then((res) => {
            if (res?.success) {
              setNextButtonLoading(false);
              // fetchProgramInfo();
              props.onNextClick();
            }
          })
          .catch((error) => {
            setNextButtonLoading(false);
          });
      }
    } else {
      setNextButtonLoading(false);
      dispatch(showSnackbar("error", ["Please select at least one program"]));
    }
  };

  useEffect(() => {
    if (templateInfo) {
      templateInfo?.programme_info_modules &&
        setChekedFields(
          templateInfo?.programme_info_modules.map((dd) => dd.module_id)
        );
      // props?.setStepperData(templateInfo?.header_name || currentSelection?.template_name || "Standard executive coaching");
      // props?.setHeaderType("programme_info");
      const tempCheckData = {};
      Object.keys(templateInfo).map((keys) => {
        if (
          templateInfo[keys] &&
          keys !== "program_type" &&
          keys !== "programme_info_modules" &&
          keys !== "description" &&
          keys !== "duration_in_month"
        )
          tempCheckData[keys] = true;
      });
      setCheckBoxValue({
        ...checkBoxValue,
        ...tempCheckData,
      });
    }
    templateInfo && setProgramRateValue(templateInfo?.program_type);
  }, [templateInfo?.programme_info_modules, templateInfoLoader]);

  useEffect(() => {
    if (Boolean(checkBoxValue?.other_charge_additionally) == false) {
      setOtherTextState({
        other_charge_additionally_value: "",
      });
    } else if (Boolean(checkBoxValue?.other_optional_extras) == false) {
      setOtherTextState({
        other_optional_extras_value: "",
      });
    }
  }, [checkBoxValue]);

  useEffect(() => {
    if (templateInfo) {
      setOtherTextState({
        other_charge_additionally_value:
          templateInfo?.other_charge_additionally_value,
        other_optional_extras_value: templateInfo?.other_optional_extras_value,
      });

      setCheckBoxValue({
        calls_between_sessions: Boolean(templateInfo?.calls_between_sessions),
        updates_on_progress: Boolean(templateInfo?.updates_on_progress),
        travel_time: Boolean(templateInfo?.travel_time),
        programme_survey_questions: Boolean(
          templateInfo?.programme_survey_questions
        ),
        session_prep: Boolean(templateInfo?.session_prep),
        other_charge_additionally: Boolean(
          templateInfo?.other_charge_additionally
        ),
        extra_session: Boolean(templateInfo?.extra_session),
        notes_consolidation: Boolean(templateInfo?.notes_consolidation),
        sourcing_and_providing_resources: Boolean(
          templateInfo?.sourcing_and_providing_resources
        ),

        coaching_agreement_form: Boolean(templateInfo?.coaching_agreement_form),
        evaluation_form: Boolean(templateInfo?.evaluation_form),
        coaching_request_form: Boolean(templateInfo?.coaching_request_form),
        coaching_review_form: Boolean(templateInfo?.coaching_review_form),
        // add forms newly param
        coaching_initiation_form: Boolean(
          templateInfo?.coaching_initiation_form
        ),
        quality_assurance_form: Boolean(templateInfo?.quality_assurance_form),
        pre_questionnaire_form: Boolean(templateInfo?.pre_questionnaire_form),
        mid_term_review_form: Boolean(templateInfo?.mid_term_review_form),
        follow_up_form: Boolean(templateInfo?.follow_up_form),
        stmt_of_work_form_client_name: Boolean(
          templateInfo?.stmt_of_work_form_client_name
        ),
        stmt_of_work_form_partner_name: Boolean(
          templateInfo?.stmt_of_work_form_partner_name
        ),

        straight_match: Boolean(templateInfo?.straight_match),
        straight_match_with_chemistry: Boolean(
          templateInfo?.straight_match_with_chemistry
        ),
        short_list: Boolean(templateInfo?.short_list),

        verbal_360: Boolean(templateInfo?.verbal_360),
        attending_meetings: Boolean(templateInfo?.attending_meetings),
        online_360: Boolean(templateInfo?.online_360),
        team_session: Boolean(templateInfo?.team_session),
        email_360: Boolean(templateInfo?.email_360),
        stakeholder_calls: Boolean(templateInfo?.stakeholder_calls),
        psychometrics: Boolean(templateInfo?.psychometrics),
        shadowing: Boolean(templateInfo?.shadowing),
        interim_review_meeting: Boolean(templateInfo?.interim_review_meeting),
        travel_times: Boolean(templateInfo?.travel_times),
        extra_sessions: Boolean(templateInfo?.extra_sessions),
        feedback_sessions: Boolean(templateInfo?.feedback_sessions),
        other_optional_extras: Boolean(templateInfo?.other_optional_extras),
      });
      setTextAreaValue({
        ...textAreaValue,
        description: templateInfo?.description,
        duration_in_month: templateInfo?.duration_in_month,
      });
    }
  }, [templateInfo]);

  const handleModal = (boolProps) => {
    setManageModal(boolProps);
  };
  const handleChangeData = (event) => {
    setInputValue(event.target.value);
  };

  const handleInputSubmit = () => {
    if (inputValue) {
      if (modalLabel == "youAreAllowedChargeAdditionally") {
        youAreAllowedChargeAdditionally.push({
          id: Math.floor(Math.random() * (100 - 1 + 1) + 1),
          name: inputValue.replace(/ /g, "_").toLowerCase(),
          value: inputValue,
        });
        setYouAreAllowedChargeAdditionally(youAreAllowedChargeAdditionally);
        setManageModal(false);
        setInputValue("");
      } else {
        optionalAuthorisation.push({
          id: Math.floor(Math.random() * (100 - 1 + 1) + 1),
          name: inputValue.replace(/ /g, "_").toLowerCase(),
          value: inputValue,
        });
        setOptionalAuthorisation(optionalAuthorisation);
        setManageModal(false);
        setInputValue("");
      }
    } else {
      setModalSubmitFlag(true);
    }
  };

  const addSubItemsModal = () => {
    return (
      <Dialog
        open={manageModal}
        fullWidth={true}
        maxWidth={"xs"}
        onClose={() => {
          handleModal(false);
        }}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          <Typography variant="h1">Add sub items</Typography>
        </DialogTitle>
        <DialogContent>
          <TextField
            error={modalSubmitFlag && inputValue == "" ? true : false}
            helperText={
              modalSubmitFlag && inputValue == ""
                ? "Please enter the value.!"
                : ""
            }
            autoFocus
            margin="dense"
            id="item"
            label="Sub items"
            type="text"
            fullWidth
            onChange={handleChangeData}
          />
          <br />
          <br />
        </DialogContent>
        <DialogActions>
          <Button
            disableElevation
            color="primary"
            onClick={() => {
              handleModal(false);
            }}
          >
            Cancel
          </Button>
          <Button type="submit" color="primary" onClick={handleInputSubmit}>
            Add
          </Button>
        </DialogActions>
      </Dialog>
    );
  };
  return (
    <>
      <form
        spellCheck="false"
        onSubmit={handleSubmit}
        className={classes.formTab}
      >
        <Container maxWidth="xl">
          {templateInfoLoader && moduleSetupLoading && <Loader />}
          <Grid
            style={{
              padding: "10px 0px 0px 2.5rem",
              marginTop: "1.5rem",
              marginBottom: "1rem",
            }}
          >
            <CustomInput
              targetId={"description"}
              id="description"
              name="description"
              multiline
              parentcall={handleTextAreaValue}
              required
              variant="outlined"
              style={{ backgroundColor: "#fff" }}
              rows={4}
              placeholder="Description"
              defaultValue={textAreaValue?.description}
            />
          </Grid>
          <Grid xs={4} className={classes.duration}>
            <Typography variant="h2" style={{ marginRight: "10px" }}>
              Assignment duration
            </Typography>
            <CustomInput
              targetId={"duration_in_month"}
              id="duration_in_month"
              name="duration_in_month"
              parentcall={handleTextAreaValue}
              required
              variant="outlined"
              style={{ backgroundColor: "#fff" }}
              placeholder="Assignment duration"
              type={"number"}
              value={textAreaValue?.duration_in_month}
              InputProps={{ inputProps: { min: 0 } }}
            />
            <Typography variant="h2" style={{ marginLeft: "10px" }}>
              (in months)
            </Typography>
          </Grid>

          <Grid>
            <Grid
              style={{
                padding: "10px 0px 0px 50px",
                display: "flex",
                justifyContent: "space-between",
              }}
              container
              spacing={2}
            >
              <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>
                Program rate includes
              </Typography>
              {/*<h2 style={{color: 'red'}}>{Array.from(moduleSetups).length && !submitFlag && Array.from(chekedFields).length ? null : "Please select at least one program.!"}</h2>*/}
            </Grid>
            <Grid
              container
              xs={12}
              spacing={2}
              direction="row"
              alignItems="center"
              justify="flex-start"
              style={{ padding: "0px 40px", marginTop: "16px" }}
            >
              <Grid item xs={12}>
                <Typography variant="h2" style={{ fontWeight: "bold" }}>
                  Most frequently modules
                </Typography>
              </Grid>
              <Grid container item xs={12}>
                {moduleSetups?.map((data, index) => {
                  return (
                    <>
                      <Grid item xs={3}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="module_ids[]"
                              color="primary"
                              checked={chekedFields.includes(data.id)}
                              value={data.id}
                              onChange={handleProgramRate}
                            />
                          }
                          label={
                            <Typography variant="h2">
                              {data.module_name}
                            </Typography>
                          }
                          className={classes.paper}
                        />
                      </Grid>
                      {data.module_name === "Extension coaching session" && (
                        <Grid item xs={12}>
                          <Typography
                            variant="h2"
                            style={{ fontWeight: "bold", marginTop: "14px" }}
                          >
                            Other modules
                          </Typography>
                        </Grid>
                      )}
                    </>
                  );
                })}
              </Grid>
            </Grid>
          </Grid>
          <Divider style={{ margin: "3rem 0 1.5rem 0px" }} />

          {/* Form */}
          <Grid
            container
            xs={12}
            spacing={2}
            direction="row"
            alignItems="center"
            justify="flex-start"
            style={{ padding: "0px 40px", marginTop: "16px" }}
          >
            <Grid item xs={12}>
              <Typography variant="h2" style={{ fontWeight: "bold" }}>
                Forms
              </Typography>
            </Grid>
            <Grid container item xs={12}>
              {Array.from(formsArray).map((data) => {
                return (
                  <>
                    <Grid item xs={3}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            name={data?.name}
                            color="primary"
                            checked={Boolean(checkBoxValue[data?.name])}
                            onChange={handleCheckboxValue}
                          />
                        }
                        label={
                          <Typography variant="h2">{data?.value}</Typography>
                        }
                        className={classes.paper}
                      />
                    </Grid>
                  </>
                );
              })}
            </Grid>
          </Grid>
          <Divider style={{ margin: "3rem 0 1.5rem 0px" }} />

          {/* Assigning Coach */}
          <Grid
            container
            xs={12}
            spacing={2}
            direction="row"
            alignItems="center"
            justify="flex-start"
            style={{ padding: "0px 40px", marginTop: "16px" }}
          >
            <Grid item xs={12}>
              <Typography variant="h2" style={{ fontWeight: "bold" }}>
                Assigning coach
              </Typography>
            </Grid>
            <Grid container item xs={12}>
              {Array.from(assignCoachArray).map((data) => {
                return (
                  <>
                    <Grid item xs={3}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            name={data?.name}
                            color="primary"
                            checked={Boolean(checkBoxValue[data?.name])}
                            // value={checkBoxValue?.straight_match}
                            onChange={handleCheckboxValue}
                          />
                        }
                        label={data?.value}
                        className={classes.paper}
                      />
                    </Grid>
                  </>
                );
              })}
            </Grid>
          </Grid>
          {<Divider style={{ margin: "3rem 0 1.5rem 0px" }} />}
          {/* You are allowed to charge additionally for */}
          {programRateValue === "external" ? (
            <Grid
              container
              xs={12}
              spacing={2}
              direction="row"
              alignItems="center"
              justify="flex-start"
              style={{ padding: "0px 40px", marginTop: "16px" }}
            >
              <Grid container item xs={12}>
                <Grid
                  item
                  xs={2}
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Typography variant="h2" style={{ fontWeight: "bold" }}>
                    You are allowed to charge additionally for
                  </Typography>
                </Grid>
                <Grid>
                  <Button
                    color="primary"
                    variant="outlined"
                    startIcon={<AddSharpIcon />}
                    style={{ marginLeft: "1rem", textTransform: "capitalize" }}
                    onClick={() => {
                      handleModal(true);
                      setModalLabel("youAreAllowedChargeAdditionally");
                    }}
                  >
                    Add
                  </Button>
                </Grid>
              </Grid>
              <Grid container item xs={12}>
                {Array.from(youAreAllowedChargeAdditionally)?.map((data) => {
                  return (
                    <>
                      <Grid item xs={3}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name={data?.name}
                              color="primary"
                              checked={Boolean(checkBoxValue[data?.name])}
                              // value={Boolean(checkBoxValue[data?.name])}
                              onChange={handleCheckboxValue}
                            />
                          }
                          label={
                            <Typography variant="h2">{data?.value}</Typography>
                          }
                          className={classes.paper}
                        />
                      </Grid>
                    </>
                  );
                })}

                {Boolean(checkBoxValue?.other_charge_additionally) ? (
                  <CustomInput
                    variant="outlined"
                    id="other_charge_additionally_value"
                    name={"other_charge_additionally_value"}
                    parentcall={(value, name) => {
                      handleOtherTextStateValue(value, name);
                    }}
                    value={otherTextState?.other_charge_additionally_value}
                    InputLabelProps={{ shrink: true }}
                  />
                ) : null}
              </Grid>

              {programRateValue === "external" ? (
                <Divider style={{ margin: "2.5rem 0 1.5rem 0px" }} />
              ) : null}
            </Grid>
          ) : null}

          {/* Optional extras needing authorisation */}
          <Grid
            container
            xs={12}
            spacing={2}
            direction="row"
            alignItems="center"
            justify="flex-start"
            style={{ padding: "0px 40px", marginTop: "16px" }}
          >
            <Grid container tem xs={12}>
              <Grid
                item
                xs={2}
                style={{ display: "flex", alignItems: "center" }}
              >
                <Typography variant="h2" style={{ fontWeight: "bold" }}>
                  Optional extras needing authorisation
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Button
                  color="secondary"
                  variant="contained"
                  startIcon={<AddSharpIcon />}
                  style={{ marginLeft: "1rem", textTransform: "capitalize" }}
                  onClick={() => {
                    handleModal(true);
                    setModalLabel("autorization");
                  }}
                >
                  Add
                </Button>
              </Grid>
            </Grid>
            <Grid container item xs={12}>
              {Array.from(optionalAuthorisation).map((data) => {
                return (
                  <>
                    <Grid item xs={3}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            name={data?.name}
                            color="primary"
                            checked={Boolean(checkBoxValue[data?.name])}
                            // value={checkBoxValue?.verbal_360}
                            onChange={handleCheckboxValue}
                          />
                        }
                        label={
                          <Typography variant="h2">{data?.value}</Typography>
                        }
                        className={classes.paper}
                      />
                    </Grid>
                  </>
                );
              })}
              {Boolean(checkBoxValue?.other_optional_extras) ? (
                <CustomInput
                  variant="outlined"
                  id="other_optional_extras_value"
                  name={"other_optional_extras_value"}
                  parentcall={(value, name) => {
                    handleOtherTextStateValue(value, name);
                  }}
                  value={otherTextState?.other_optional_extras_value}
                  InputLabelProps={{ shrink: true }}
                />
              ) : null}
            </Grid>
          </Grid>
          {manageModal && modalLabel == "youAreAllowedChargeAdditionally"
            ? addSubItemsModal()
            : addSubItemsModal()}
        </Container>

        <div className={classes.bottomBar}>
          <Button
            onClick={() => props.handleClose()}
            className={classes.buttonCss}
            style={{ marginRight: "10px" }}
            disabled={nextButtonLoading}
            type="submit"
            variant="contained"
          >
            Close
          </Button>
          <Button
            className={classes.buttonCss}
            disabled={nextButtonLoading}
            type="submit"
            variant="contained"
            color="secondary"
          >
            Next
          </Button>
        </div>
      </form>
    </>
  );
};
export default StandardExecutiveCoaching;
